import { pluginApi } from 'services/api';
import { SendOptOut } from './interfaces';

const sendExcludeParticipant = (data: SendOptOut) =>
  pluginApi.post('/participants/exclude-participant', data);

export const SendParticipantExclusion = {
  sendExcludeParticipant,
};
